// #region ORDER STATUS: ENUM

import { KeyInfoInterface } from "@/interfaces/KeyInfoInterface";
import { RestrictType } from "@/interfaces/RestrictType";

export enum ProductVariantStatusEnum {
  ACTIVE = 'active',
  CONCEPT = 'concept',
  INACTIVE = 'inactive',
};

// #endregion

// #region ORDER STATUS: KEY INFO

export class ProductVariantStatusKeyInfoClass implements RestrictType<ProductVariantStatusEnum, KeyInfoInterface, ProductVariantStatusKeyInfoClass> {
  get [ProductVariantStatusEnum.ACTIVE](): KeyInfoInterface {
    return {
      label: 'Active',
      labelShort: 'Active',
    }
  }

  get [ProductVariantStatusEnum.CONCEPT](): KeyInfoInterface {
    return {
      label: 'Concept',
      labelShort: 'Concept',
    }
  }

  get [ProductVariantStatusEnum.INACTIVE](): KeyInfoInterface {
    return {
      label: 'Inactive',
      labelShort: 'Inactive',
    }
  }
}

export const ProductVariantStatusKeyInfo = new ProductVariantStatusKeyInfoClass();

// #endregion
